import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { badges as badgesApi } from 'redux/modules/api'
import { modal, notification, logError } from 'redux/modules/app'
import { get } from 'lodash'

function decorator(config = {}) {
  const enhance = compose(
    connect(
      ({ api }) => ({
        local: {},
        badges: api.badges,
        awardDetail: api.awards.detail
      }),
      { ...badgesApi, modal, notification, logError }
    )
  )

  return ComposedComponent => {
    class Badges extends Component {
      static propTypes = {
        badges: PropTypes.object.isRequired,
        getAwardBadges: PropTypes.func.isRequired,
        getBadges: PropTypes.func.isRequired,
        getBadgesProgress: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        modal: PropTypes.func,
        decoFilter: PropTypes.string,
        awardDetail: PropTypes.object
      }

      static defaultProps = {
        params: {}
      }

      componentDidMount() {
        const { params } = this.props

        config.list && this.handleGetAwardBadges(params, this.handleGetBaseFilter())

        if (config.loadBadges) {
          const organizationId = get(this.props, 'award.organization.id')

          this.handleGetBadges(true, organizationId)
        }

        if (config.loadBadgesProgress) {
          this.handleGetBadgesProgress(get(this.props, 'award.id'))
        }
      }

      handleGetAwardBadges = (params, baseFilter, cfgOrganizationId = 0) =>
          this.props.getAwardBadges(params, baseFilter, config.listReadParams, cfgOrganizationId)
              .catch(this.handleError)

      handleGetBadges = (mergeGroups = false, cfgOrganizationId = 0) => {
        this.props.getBadges(mergeGroups, cfgOrganizationId)
      }

      handleGetBadgesProgress = awardId => {
        this.props.getBadgesProgress(awardId)
      }

      handleGetBaseFilter = filter => {
        const { decoFilter } = this.props

        switch (decoFilter || config.filter || filter) {
          default:
            return `award.id=${get(this.props, 'award.id')}`
        }
      }

      handleError = err => {
        console.log('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }

      render() {
        const params = {
          ...this.props,
          local: undefined
        }

        return (
          <ComposedComponent
            {...params}
            getAwardBadges={this.handleGetAwardBadges}
            getBadges={this.handleGetBadges}
            onGetBadgesProgress={this.handleGetBadgesProgress}
          />
        )
      }
    }
    return enhance(Badges)
  }
}

export default decorator
